module.exports = __webpack_public_path__ + "static/img/15areaA_3.afc61fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/15areaA_3.png
// module id = 1013
// module chunks = 1